import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import {
	setFlags,
	setLoading,
	setError,
	setSuccessfullyUpdated,
	updateSingleFlag,
} from 'state/reducers/feature-flags.reducer';
import { setSuccessMessage } from 'state/reducers/ui.reducers';
import { setErrorMessage } from 'utils/index';

const apiService = ApiService.getInstance();

export const getAllFeatureFlags = () => {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		try {
			const response = await apiService.execute(apiFunctionsEnum.GET_ALL_FEATURE_FLAGS);
			const flags = response.data.featureFlags;
			dispatch(setFlags(flags));
			return flags;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
		} finally {
			dispatch(setLoading(false));
		}
	};
};

export const updateFeatureFlag = (name: string, isEnabled: boolean, description?: string) => {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setLoading(true));
		try {
			const response = await apiService.execute(apiFunctionsEnum.UPDATE_FEATURE_FLAG, {
				name,
				isEnabled,
				description,
			});

			// Update the single flag in the state
			dispatch(updateSingleFlag({ name, isEnabled, description }));
			dispatch(setSuccessfullyUpdated(true));
			dispatch(setSuccessMessage(true));

			return response.data;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
			dispatch(setSuccessfullyUpdated(false));
		} finally {
			dispatch(setLoading(false));
		}
	};
};
